import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App.tsx';
import './index.css';
import { PasswordProtection } from './components/PasswordProtection.tsx';

// Check if we're in production mode
const isProduction = import.meta.env.MODE === 'production';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PasswordProtection isProduction={isProduction}>
      <App />
      <Analytics />
    </PasswordProtection>
  </StrictMode>
);